import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { Plano, Classe, FundamentoLegal } from '../models/edocs.model';
import { Patriarca } from '../models/edocs.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EDocsService extends BaseService {
    controllerRoute = 'EDocs';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getPatriarcas(): Promise<IBaseModel<Patriarca[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Patriarca[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/Patriarcas`));
    }

    public async getPlanosAtivos(idPatriarca: string): Promise<IBaseModel<Plano[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Plano[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/PlanosAtivos/${idPatriarca}`));
    }

    public async getClassesAtivas(idPlano: string): Promise<IBaseModel<Classe[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Classe[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/ClassesAtivas/${idPlano}`));
    }

    public async getFundamentosLegaisPatriarca(idPatriarca: string): Promise<IBaseModel<FundamentoLegal[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<FundamentoLegal[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/FundamentosLegais/${idPatriarca}`));
    }

    public async getFundamentosLegaisCidadao(): Promise<IBaseModel<FundamentoLegal[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<FundamentoLegal[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/FundamentosLegais`));
    }
}
